import { EServiceGroup } from "@constants";
import { ICart, ICartOffer, ICatalogOffer } from "@features/cart/ICart";
import { IFlyingCart, IFlyingCartOffer } from "@features/cart/IFlyingCart";

export const checkCartOfferByServiceGroup = (offer: ICartOffer | undefined, serviceGroup: EServiceGroup): boolean =>
    Boolean(offer?.baseOffer.serviceGroup?.includes(serviceGroup));

export const checkFlyingCartOfferByServiceGroup = (offer: IFlyingCartOffer, serviceGroup: EServiceGroup) =>
    offer.baseOffer.serviceGroup === serviceGroup;

export const hasOfferBroadband = (offers: ICartOffer[] | IFlyingCartOffer[] | IFlyingCart): boolean => {
    if (Array.isArray(offers)) {
        if (offers.length === 0) {
            return false;
        }

        const firstOffer = offers[0];
        if ("recurringChargeAmount" in firstOffer) {
            return (offers as ICartOffer[]).some((offer) => checkCartOfferByServiceGroup(offer, EServiceGroup.SA_BB));
        }

        return (offers as IFlyingCartOffer[]).some((offer) =>
            checkFlyingCartOfferByServiceGroup(offer, EServiceGroup.SA_BB)
        );
    }

    return offers.offers.some((offer) => checkFlyingCartOfferByServiceGroup(offer, EServiceGroup.SA_BB));
};

export const selectOfferInCartByServiceGroup = (
    cart: ICart | undefined,
    serviceGroup: EServiceGroup
): ICartOffer | undefined => cart?.offers.find((offer) => checkCartOfferByServiceGroup(offer, serviceGroup));

export const selectOfferByServiceGroup = (
    offerList: ICatalogOffer[],
    serviceGroup: EServiceGroup
): ICatalogOffer | undefined => offerList.find((offer) => offer.serviceGroup === serviceGroup);

export const getIsAddingBroadbandOfferAllowed = (cart: ICart): boolean =>
    cart.nbrAdditionalAllowedBroadbandSubscriptions !== undefined &&
    cart.nbrAdditionalAllowedBroadbandSubscriptions > 0;

export const getOfferPrice = (offer: ICatalogOffer): number =>
    offer.discountedRecurringChargeAmount ?? offer.recurringChargeAmount;
